import React, { useState, useEffect } from 'react';
import { AppBarComponent } from '@syncfusion/ej2-react-navigations';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { IDocumentLoader } from './types/document';
import { ToastComponent } from '@syncfusion/ej2-react-notifications';
import AboutDocumentDialog from './about';
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

interface IWordAppProps {
    enableRTL: boolean;
    documentLoader: IDocumentLoader;
}

function blobToBase64(blob: Blob) {
    return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}

const intoString = (value: unknown) => (value as any)?.toString?.() ?? '';

function ImageApp(props: IWordAppProps) {
    const enableRTL : boolean = props.enableRTL;
    const documentLoader : IDocumentLoader = props.documentLoader;

    const [ documentName, setDocumentName ] = useState <string>('');
    const [ loaded, setLoaded ] = useState <number>(0);
    const [ imageSrc, setImageSrc ] = useState <string>('');
    
    const onLoadDefault = async () : Promise<void> => {

        setDocumentName(documentLoader.document.name);
        
        var data = new Blob([new Uint8Array(props.documentLoader.document.body.data)]);
        const imageStr : string | unknown = await blobToBase64(data);
        if (imageStr) {
            setImageSrc(intoString(imageStr));
            setLoaded(1);
        } else 
            setLoaded(2);
    }

    function downloadDocument() : void {
        var data = new Blob([new Uint8Array(props.documentLoader.document.body.data)]);
        var url = window.URL.createObjectURL(data);
        const tempLink = document.createElement('a');
        tempLink.href = url;
        tempLink.setAttribute('download', props.documentLoader.document.name + ' (v' + props.documentLoader.document.metadata.versionNumber.toString() + ')' + 
            props.documentLoader.document.metadata.file.ext);
        tempLink.click();
        window.URL.revokeObjectURL(url);
    }
    
    let toastInstance: ToastComponent;
    function toastCreated(): void {
        if (loaded === 2)
            toastInstance.show();
    }

    useEffect(() => {
        onLoadDefault();
    }, []);

    return (
        <React.Fragment>
            <div className="row" style={{ maxHeight: '40px' }}>
                <div className="col-md-12">
                <AppBarComponent mode="Dense" colorMode="Primary">                    
                    <AboutDocumentDialog documentLoader={documentLoader}/>
                    <span className="dense">Contentum: {documentName}</span>
                    <div className="e-appbar-spacer"></div>
                    <ButtonComponent cssClass='e-inherit login' iconCss="e-icons e-download" onClick={() => { downloadDocument() }}>Завантажити</ButtonComponent>
                </AppBarComponent>
                </div>
            </div>
                <div id="editorContainerElement">
                    {loaded === 1 && imageSrc && 
                        <Zoom>
                            <div className="image-viewer">
                                <img src={imageSrc} alt={`Image`} className="image" style={{ width: '95%', verticalAlign: 'bottom' }}/>
                            </div>
                        </Zoom>
                    }
                </div>
            { (loaded === 2) &&
                <ToastComponent 
                    ref={(toast: any) => toastInstance = toast!} 
                    title="На жаль, сталася помилка"
                    content="Ми не можемо отримати документ з Contentum"
                    created={toastCreated} 
                    showProgressBar={true}
                    timeOut={10000}
                    position={{ X: 'Right', Y: 'Top' }}
                    enableRtl={enableRTL}
                />
            }
        </React.Fragment>
    )
}

export default ImageApp;